import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-cream',
  templateUrl: './project-cream.component.html',
  styleUrls: ['./project-cream.component.scss']
})
export class ProjectCreamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
